import classNames from 'classnames'

import Modal from 'ui-component-library/components/00-Primitives/Modal'
import TextBlock from 'ui-component-library/components/00-Primitives/TextBlock'
import Button from 'content-components/_Primatives/Button'
import style from './style.scss'

export type Props = {
  acceptButtonText: string
  bodyText: string
  className?: string
  onAccept: () => void
}

function PolicyBanner(props: Props) {
  const { className, bodyText, acceptButtonText, onAccept } = props

  return (
    <Modal>
      <div className={classNames(style.wrapper, className)}>
        <TextBlock className={style.bodyText}>{bodyText}</TextBlock>
        <Button
          variant='primaryBlue'
          onClick={onAccept}
          aria-label='accept cookie policy'
        >
          {acceptButtonText}
        </Button>
      </div>
    </Modal>
  )
}

export default PolicyBanner
